import api from "../utils/API";

const getAllSearchLists = () => {
  return api.get(`/candidatmanagement/recherche/searchlists`);
};

const advancedSearchIA = (payload) => {
  const compact = (obj) => {
    const out = Array.isArray(obj) ? obj.filter((v) => v !== "" && v != null) : { ...obj };
    if (!Array.isArray(obj)) {
      Object.keys(out).forEach((k) => {
        const v = out[k];
        const isEmptyArr = Array.isArray(v) && v.length === 0;
        const isEmptyStr = typeof v === "string" && v.trim() === "";
        const isEmptyObj = v && typeof v === "object" && !Array.isArray(v) && Object.keys(v).length === 0;
        if (isEmptyArr || isEmptyStr || isEmptyObj || v == null) delete out[k];
      });
    }
    return out;
  };

  return api.post("/search/advanced", compact(payload));
};

const resolveCandidatesForIa = (uploadIds = []) =>
    api.post("/candidatsmanagement/candidats/by-upload-ids", { ids: uploadIds });

const getConnectedUserId = () => {
  try {
    const raw = localStorage.getItem("userData");
    if (!raw) return "";

    const userData = JSON.parse(raw);
    return userData?.uuid || userData?.id || userData?.userId || "";
  } catch (_e) {
    return "";
  }
};

const agentTextSearch = (text, userId = "") => {
  const connectedUserId = getConnectedUserId();
  return api.post("/agent/query", { text, user_id: userId || connectedUserId || "" });
};

const chatMessage = (message, userId = "") => {
  const connectedUserId = getConnectedUserId();
  return api.post("/chat/message", { message, user_id: userId || connectedUserId || "" });
};

const getTalentBoard = (queryString = "") =>
  api.get(`/candidatmanagement/talent-board${queryString ? `?${queryString}` : ""}`);

export { getAllSearchLists, advancedSearchIA, resolveCandidatesForIa, agentTextSearch, chatMessage, getTalentBoard };
